import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-components/render-engine/classes/base-root-option";

export default class RequiredContexts extends BaseRootOption {
  static userInterfaceComponent = () => {
    return {
      useCustomLabel: true,
      label: "Required Contexts",
      component: inspectorTools.REQUIRED_CONTEXTS,
    };
  };

  static defaultValue = {};
}
